var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Checkbox, createStyles, makeStyles, FormControlLabel, } from "@material-ui/core";
import check24 from "../../assets/icons/check24.svg";
import check16 from "../../assets/icons/check16.svg";
const sizeToPx = {
    small: 14,
    medium: 14,
    large: 20,
};
export default (_a) => {
    var { label = "", FormControlLabelProps, size = "medium", fullWidth } = _a, props = __rest(_a, ["label", "FormControlLabelProps", "size", "fullWidth"]);
    const classes = useStyles({ size: sizeToPx[size], fullWidth });
    return (React.createElement(FormControlLabel, Object.assign({}, FormControlLabelProps, { className: classes.root, classes: {
            label: classes.label,
        }, control: React.createElement(Checkbox, Object.assign({ classes: {
                root: classes.checkbox,
                disabled: classes.checkboxDisabled,
            }, color: "default", checkedIcon: React.createElement("span", { className: classes.icon + " " + classes.checkedIcon }), icon: React.createElement("span", { className: classes.icon }) }, props)), label: label })));
};
const useStyles = makeStyles((theme) => createStyles({
    root: ({ fullWidth }) => ({
        margin: 0,
        display: fullWidth ? "flex" : undefined,
        "&:hover $icon": {
            backgroundColor: theme.palette.toggle.hover,
        },
        "&:hover $checkedIcon": {
            backgroundColor: theme.palette.toggle.checkedHover,
        },
    }),
    label: Object.assign(Object.assign({}, theme.typography.p2), { color: theme.palette.text.primary, fontSize: "14px", marginLeft: 15, lineHeight: "20px", userSelect: "none" }),
    checkbox: ({ size }) => ({
        height: size,
        width: size,
        padding: 0,
        "& .MuiIconButton-label": {
            height: "inherit",
            width: "inherit",
        },
    }),
    checkboxDisabled: {
        background: theme.palette.toggle.disabled,
        "& $label": {
            color: theme.palette.text.disabled,
        },
        "& $icon": {
            backgroundColor: theme.palette.icon.disabled + "!important",
        },
    },
    icon: ({ size }) => ({
        display: "block",
        width: size,
        height: size,
        backgroundColor: theme.palette.toggle.inactive,
        border: `1px solid ${theme.palette.border.textField}`,
        boxSizing: "border-box",
        borderRadius: 2,
    }),
    checkedIcon: ({ size }) => ({
        border: "none",
        backgroundColor: theme.palette.toggle.checkedEnable,
        backgroundImage: `url(${size === 20 ? check24 : check16})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
    }),
}));
//# sourceMappingURL=FTLCheckbox.js.map